import React from 'react';
import { ChevronDown, Maximize2, Minimize2 } from 'lucide-react';

interface PlayerHeaderProps {
  onMinimize: () => void;
  onToggleFullscreen: () => void;
  isFullscreen: boolean;
}

export const PlayerHeader: React.FC<PlayerHeaderProps> = ({
  onMinimize,
  onToggleFullscreen,
  isFullscreen,
}) => {
  return (
    <div className="flex items-center justify-between mb-8">
      <button
        onClick={onMinimize}
        className="p-2 hover:bg-zinc-800 rounded-full transition"
      >
        <ChevronDown className="w-6 h-6" />
      </button>
      <h2 className="text-lg font-semibold">Now Playing</h2>
      <button
        onClick={onToggleFullscreen}
        className="p-2 hover:bg-zinc-800 rounded-full transition"
      >
        {isFullscreen ? (
          <Minimize2 className="w-6 h-6" />
        ) : (
          <Maximize2 className="w-6 h-6" />
        )}
      </button>
    </div>
  );
};